
import React, { useEffect } from "react";
import { useLocation } from 'react-router-dom';

import "./FallBack.scss";
function FallBack() {
    const location = useLocation();
    const error = location.state?.error;

    useEffect(()=>{
        console.log(error)
    },[])
    return (
        <React.Fragment>
            <div className="fallback-container">
    <div className="middle">
        <div className="bg"></div>
            <div className="title">
                Oops
            </div>
            <div className="desc">
                Something went wrong. <br/>
                Please try again.<br></br>
            </div>
      </div>
</div>
        </React.Fragment>
    )
}

export default FallBack